"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useIntegration(idOrKey) {
  const { item: integration, ...rest } = useElement(
    WorkspaceElementType.Integration,
    idOrKey,
    (integrationApp) => idOrKey ? integrationApp.integration(idOrKey) : void 0
  );
  return { integration, ...rest };
}

export { useIntegration };
